document.addEventListener("DOMContentLoaded", function () {
  const select = document.getElementById("product-variant-select")
  const titleCell = document.getElementById("selected-product-cell")
  const skinsGroupCell = document.getElementById("skins-group-cell")
  const skinStyle = document.getElementById("skin-style")

  if (!select || !titleCell || !skinsGroupCell) return

  function updateTable() {
    const selectedOption = select.options[select.selectedIndex]
    const title = selectedOption?.dataset.title || "—"
    const skinsGroup = selectedOption?.dataset.skinsGroup || "—"
    const trimToFit = selectedOption?.dataset.trimToFit || "—"

    titleCell.textContent = title
    skinStyle.textContent === "pre-cut"
      ? (skinsGroupCell.textContent = skinsGroup)
      : (skinsGroupCell.textContent = trimToFit)
  }

  select.addEventListener("change", updateTable)

  updateTable()
})
